const env = {
  baseApiUrl: process.env.REACT_APP_BASE_API_URL || '',
  entraClientId: process.env.REACT_APP_ENTRA_CLIENT_ID || '',
  entraTenantId: process.env.REACT_APP_ENTRA_TENANT_ID || '',
  entraRedirectUri: process.env.REACT_APP_ENTRA_REDIRECT_URI || '',
  ssoProviderName: process.env.REACT_APP_SSO_PROVIDER_NAME || 'Sign in with LLX Entra',
};

export default env;
